// Strong relationship with application-cycle.js
// Should probably merge or reference each other.

import * as routeNames from '@/router/route-names'

const PROFILE = 'Profile'
const SUMMARY = 'Summary'
const SCHEDULES = 'Schedules'
const APPLICATIONS = 'Applications'
const LOSS_RUNS = 'LossRuns'
const DOCUMENTS = 'Documents'
const MOD = 'Mod'
const FINANCIALS = 'Financials'
const SUBMISSION = 'Submission'
const INTERNAL_QUOTE_REVIEW = 'InternalQuoteReview'
const SUBJECTIVITIES = 'Subjectivities'
const QUOTE_REVIEW = 'QuoteReview'
const BIND_DECISION = 'BindDecision'
const POLICY_SELECTION = 'PolicySelection'

const progressSectionType = {
  PROFILE,
  SUMMARY,
  SCHEDULES,
  APPLICATIONS,
  LOSS_RUNS,
  MOD,
  FINANCIALS,
  DOCUMENTS,
  SUBMISSION,
  INTERNAL_QUOTE_REVIEW,
  SUBJECTIVITIES,
  QUOTE_REVIEW,
  BIND_DECISION,
  POLICY_SELECTION,
}

const progressSection = {
  [PROFILE]: {
    name: 'Profile',
    shortName: 'Pro',
    pageName: routeNames.COMPANY_PROFILE,
    permission: 'OP_READ_COMP_PROFILE',
    className: 'prog-bar-pro',
  },
  [SUMMARY]: {
    name: 'Summary',
    shortName: 'Sum',
    pageName: routeNames.COVERAGE_SUMMARY,
    permission: 'any',
    className: 'prog-bar-sum',
  },
  [SCHEDULES]: {
    name: 'Schedules',
    shortName: 'Sch',
    pageName: routeNames.SCHEDULES,
    permission: 'OP_READ_SCHEDULES',
    className: 'prog-bar-sch',
  },
  [APPLICATIONS]: {
    name: 'Applications',
    shortName: 'App',
    pageName: routeNames.APPLICATIONS,
    permission: 'OP_READ_APPLICATIONS',
    className: 'prog-bar-app',
  },
  [LOSS_RUNS]: {
    name: 'Loss Runs',
    shortName: 'Loss',
    pageName: routeNames.LOSS_RUNS,
    permission: 'OP_READ_LOSS_RUNS',
    className: 'prog-bar-loss',
  },
  [DOCUMENTS]: {
    name: 'Documents',
    shortName: 'Docs',
    pageName: routeNames.UNDERWRITING_DOCUMENTS,
    permission: 'any',
    className: 'prog-bar-docs',
  },
  [MOD]: {
    name: 'Mod',
    shortName: 'Mod',
    pageName: routeNames.EXPERIENCE_MOD,
    permission: 'OP_READ_MOD',
    className: 'prog-bar-mod',
  },
  [FINANCIALS]: {
    name: 'Financials',
    shortName: 'Fin',
    pageName: routeNames.FINANCIALS,
    permission: 'OP_READ_FINANCIALS',
    className: 'prog-bar-fin',
  },
  [SUBMISSION]: {
    name: 'Submission',
    shortName: 'Sub',
    pageName: routeNames.SUBMIT_TO_ACCOUNT_MANAGER,
    highLightWhenNext: false,
    permission: 'any',
    className: 'prog-bar-sub',
  },
  [INTERNAL_QUOTE_REVIEW]: {
    name: 'Broker Review',
    shortName: 'IQR',
    pageName: routeNames.INTERNAL_QUOTE_REVIEW,
    permission: 'any',
    className: 'prog-bar-iqr',
  },
  [SUBJECTIVITIES]: {
    name: 'Subjectivities',
    shortName: 'Sbj',
    pageName: routeNames.SUBJECTIVITIES,
    permission: 'any',
    className: 'prog-bar-sbj',
  },
  [QUOTE_REVIEW]: {
    name: 'Quotes',
    shortName: 'QR',
    pageName: routeNames.QUOTE_REVIEW,
    permission: 'any',
    className: 'prog-bar-qr',
  },
  [BIND_DECISION]: {
    name: 'Bind',
    shortName: 'BD',
    pageName: routeNames.BIND_DECISION,
    permission: 'any',
    className: 'prog-bar-bd',
  },
  [POLICY_SELECTION]: {
    name: 'Selection',
    shortName: 'Sel',
    pageName: routeNames.POLICY_SELECTION,
    permission: 'any',
    className: 'prog-bar-sel',
  },
}

export { progressSectionType, progressSection }
